module.exports = __webpack_public_path__ + "img/business_03.77324104.jpg";